import queryString from 'query-string';
import { snakeize } from 'casing';
import Http from '../http/Http';
import snakeToCamelCase from '../../helpers/stringCase';

class TrackingPageApiLayer {
  constructor(params) {
    const { http } = params;
    this.http = http;
  }

  getTrackingPage(
    trackingPageName,
    shipmentId,
    customerId,
    version,
    trackingReference,
    customReference,
    metadataKey,
    metadataValue,
  ) {
    const query = {
      shipmentId,
      customerId,
      version: snakeToCamelCase(version),
      trackingReference,
      customReference,
      metadataKey,
      metadataValue,
    };
    const url = `shipment-tracking-pages/${trackingPageName}?${queryString.stringify(snakeize(query))}`;
    return this.http.get(url);
  }
}

export default new TrackingPageApiLayer({
  http: Http,
});
